<ng-container *ngIf="insurers.length > 0">
  <ng-container *ngFor="let insurer of insurers; let i = index">
    <div class="col-xs-12 col-md-6" id="divInsurer2">
      <h3 class="normal-title">Asegurado {{ insurer.number }}</h3>
      <div class="form-control input">
        <input
          maxlength="10"
          type="tel"
          name="dob{{ insurer.number }}}"
          id="txtDate{{ insurer.number }}"
          date-mask
          placeholder="Fecha de nacimiento (dd/mm/aaaa)"
          spellcheck="false"
          min-age="0"
          max-age="90"
          class="text-input inline text-09-d-demibold txtBirthDate"
          oncopy="return false;"
          onpaste="return false;"
          oncut="return false;"
          oncontextmenu="return false;"
          inputmode="numeric"
          [(ngModel)]="insurer.date"
          (ngModelChange)="onSubmitAnswer(insurer, i)" />
      </div>
    </div>
  </ng-container>
</ng-container>
